const workDesk = {
  state: {
    activeIndex: undefined,//工作桌面选中下表
    currentView: undefined,//展示元素
    cpNumber:0,//代办呈批单数量
  },
  mutations: {
    setActiveIndex(state, value) {
      state.activeIndex = value
    },
    setCurrentView(state, value) {
      state.currentView = value
    },
    setCpNumber(state, value) {
      state.cpNumber = value
    },
  },
}

export default workDesk



// WEBPACK FOOTER //
// ./src/store/modules/workDesk.js